import React, { FunctionComponent } from 'react';
import { Box, Text } from 'rebass/styled-components';
import styled from 'styled-components';
import { space } from 'styled-system';
import theme from 'styled-theming';

export interface ResultsEmptyProps {
  text?: React.ReactElement | string;
}

const border = theme('mode', {
  light: (props: any) => `1px dashed ${props.theme.colors.periwinkle}`,
  dark: '1px dashed rgba(255, 255, 255, 0.3)',
});

const StyledBox = styled(Box)`
  border: ${border};
  box-sizing: border-box;
  border-radius: 5px;
  ${space}
`;

const ResultsEmpty: FunctionComponent<ResultsEmptyProps> = ({ text = 'No Results' }: ResultsEmptyProps) => (
  <StyledBox py={3} px={4} mt={5}>
    <Text variant="info">{text}</Text>
  </StyledBox>
);

export default ResultsEmpty;
